/** One bucket for every room rate whose rate plan is missing. */
export const UNKNOWN_RATE_PLAN_ID = 'unknown-rate-plan';
export const UNKNOWN_RATE_PLAN_NAME = 'Unknown rate plan';
